import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-kyc-payment',
  standalone: true,
  imports: [CommonModule, FormsModule],
	templateUrl: './kyc-payment.component.html',
	styleUrl: './kyc-payment.component.scss',
})
export class KycPaymentComponent {
	formData: any = '';
	packName: any = null;
	loading = false;
	allCoupons: any = [];
	user: any = null;

	constructor(public auth: AuthService, public dataService: DataService, private router: Router,
		private http: HttpClient
	) {
		//
	}

	ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
		}

		let buttons: any = document.querySelectorAll('.payment-btn');
		let sections: any = document.querySelectorAll('.payment-section');

		buttons.forEach((button: any) => {
			button.addEventListener('click', () => {
				buttons.forEach((btn: any) =>
					btn.classList.remove('active')
				);

				button.classList.add('active');

				sections.forEach((section: any) =>
					section.classList.add('d-none')
				);

				document.getElementById(button?.dataset?.target)?.classList.remove('d-none');
			});
		});

    let kycData = localStorage.getItem('kycData');
    if(kycData) {
      this.formData = JSON.parse(kycData);
    }
	}

	getPackName(){
		const pcode: string = this.formData.package.pkg_code;
		return this.dataService.getPackageName(pcode);
	}

  payNow() {
		const uniqueId = 'TXN_' + Date.now() + '_' + Math.floor(1000 + Math.random() * 9000);
    const orderDetails = {
      amount: this.formData.package.total_amount, // Amount in INR
      transactionId: uniqueId, // Generate unique transaction ID
      userId: 'USER_'+Math.floor(1000 + Math.random() * 1000)
    };

    this.auth.initiatePayment(orderDetails).subscribe({
      next: (res) => {
        if (res.url) {
					// Redirect user to PhonePe standard payment page
					window.open(res.url, "_blank");

					if(this.user.subscribe) {
						setTimeout(()=>{
							location.href = "/institute";
						}, 1000);
					}
        }
      },
      error: (err) => console.error('Payment Error:', err)
    });
  }

	applyCoupon() {
		let retVal: any = '0.00';

		if(!this.formData.package.coupon_code) return;
		this.loading = true;

		this.dataService.getAllRecords('coupons').then((res: any) => {
      this.allCoupons = res;

			const coupon = this.allCoupons.filter((obj: any)=>{
				return obj.code == this.formData.package.coupon_code;
			});

			if(coupon && coupon.length > 0) {
				const myCoupon = coupon[0];
				const disc_type = myCoupon.disc_type;
				const disc_value = myCoupon.disc_value;
				const totAmount = this.formData.package.total_amount;

				if(disc_type=='flat') {
					this.formData.package.discount_amount = disc_value;
					this.formData.package.total_amount = totAmount - this.formData.package.discount_amount;
				} else {
					this.formData.package.discount_amount = disc_value + '%';
					const discPer: any = (totAmount * disc_value) / 100;
					this.formData.package.total_amount = totAmount - discPer;
				}
			}

      this.loading = false;
    });
	}
	

}
